"use strict";

var proteinAlphabet = require("./proteinAlphabet");

/**
 * @param {string} aaString A string of amino acid characters
 * @param {number} numsAfterDecimal the number of digits to round to after the decimal point, must be greater than 0
 * @param {boolean} divideByThree divide the final mass by three,
 *  this is useful in situtations where nucelotides are converted to
 *  amino acids in a way that the amino acid appears three times
 * @returns The sum of the mass of all amino acids in the string
 */
module.exports = function getMassOfAaString(aaString) {
  var numsAfterDecimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var divideByThree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var sumMass = 0;
  for (var i = 0; i < aaString.length; i++) {
    sumMass += proteinAlphabet[aaString[i]].mass;
  }
  if (divideByThree) {
    sumMass /= 3;
  }
  return Math.round(sumMass * Math.pow(10, numsAfterDecimal)) / Math.pow(10, numsAfterDecimal);
};